<div class="template-editor-area">
  <mat-icon [inline]="true" cdkDragHandle class="template-editor-area__icon">drag_indicator</mat-icon>

  <div
    #areaName
    [attr.contenteditable]="editMode"
    class="template-editor-area__text nowrap fs s14 text-color gray"
    (click)="enterEditMode()"
    (blur)="leaveEditMode(areaName.textContent)"
    (keydown)="nameChanged($event)"
  >
    {{ area.title }}
  </div>

  <button class="remove" mat-icon-button (click)="removeClick()">
    <app-icon [svg]="EIcon.BB_TRASH"></app-icon>
  </button>
</div>

<div class="template-editor-inspection-area-dnd-content" cdkDropListGroup>
  <div
    cdkDropList
    (cdkDropListEntered)="enter($event)"
    (cdkDropListDropped)="dropItem(areaContent.items)"
    #placeholder
  ></div>

  <div
    cdkDropList
    (cdkDropListEntered)="enter($event)"
    (cdkDropListDropped)="dropItem(areaContent.items)"
    *ngFor="let item of areaContent.items; trackBy: trackById.bind(this, 'name')"
  >
    <div cdkDragBoundary=".template-editor-inspection-area-dnd-content" cdkDrag appDragCursor>
      <app-template-editor-item
        [item]="item"
        (itemChange)="itemChange($event)"
        (enterPressed)="enterPressedHandler($event)"
        (ratingGroupAdd)="addRatingGroup($event)"
        (ratingGroupRemove)="removeRatingGroup($event)"
        (remove)="removeItem($event)"
      ></app-template-editor-item>
    </div>
  </div>

  <div>
    <button mat-button (click)="add()">
      <span class="display-flex align-items-center justify-content-center add-button">
        <mat-icon [inline]="true" class="add-button__icon">add</mat-icon>
        <span class="add-button__text">add item</span>
      </span>
    </button>
  </div>
</div>
